import { FrontendProviders } from '@prediction-market/providers';
import { Chains } from '@prisma/client';
import { BackpackWalletAdapter } from '@solana/wallet-adapter-backpack';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { Wallet } from '@solana/wallet-adapter-react';
import {
  PhantomWalletAdapter,
  PhantomWalletName,
  SolflareWalletAdapter,
} from '@solana/wallet-adapter-wallets';
import { clusterApiUrl, Connection, PublicKey } from '@solana/web3.js';
import {
  detectEmbeddedInSquadsIframe,
  SquadsEmbeddedWalletAdapter,
} from '@sqds/iframe-adapter';

import { env } from '../../env';

import { rpcFetch } from '@/lib/refetch';

export const network =
  env.VITE_PUBLIC_NETWORKS_MODE === 'mainnet'
    ? WalletAdapterNetwork.Mainnet
    : WalletAdapterNetwork.Devnet;

export const dbNetwork =
  env.VITE_PUBLIC_NETWORKS_MODE === 'mainnet'
    ? // ? Chains.SolanaMainnet
      Chains.SolanaMainnet
    : 'SolanaDevnet';

export const endpoints = env.VITE_PUBLIC_SOLANA_RPC?.split(',')
  .map((s) => s.trim())
  .filter(Boolean) ?? [clusterApiUrl(network)];

export const endpoint = endpoints[0];

export const wallets = detectEmbeddedInSquadsIframe()
  ? [
      new BackpackWalletAdapter(),
      new PhantomWalletAdapter(),
      new SolflareWalletAdapter(),
      new SquadsEmbeddedWalletAdapter('https://iframe-preview.squads.so'),
    ]
  : [
      new PhantomWalletAdapter(),
      new SolflareWalletAdapter(),
      new BackpackWalletAdapter(),
    ];

export const connection = new Connection(endpoint, {
  commitment: 'confirmed',
  fetch: rpcFetch(endpoints),
});

const providers = new FrontendProviders(connection);
export const program = providers.getPredictionMarketProgram(dbNetwork);

export const globalState =
  providers.getNetworkAddresses(dbNetwork)?.programs.predictionMarket
    .globalState ?? new PublicKey('PLEASE SET RIGHT NETWORK');

export const SIZE_DECIMALS = 100;
export const PRICE_DECIMALS = 100;
export const TOKEN_DECIMALS = 1000000;
export const PREDICTION_TARGET_PRICE_DECIMALS = 10 ** 9;

export const token =
  network === WalletAdapterNetwork.Mainnet
    ? new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v')
    : new PublicKey('G2zP9rmjfLTmykWyyWU1vLkwZb784V4SGfEu43EAQK1V');

export const PREDICTION_SEEDS = {
  VAULT_SEED: 'vault',
  PREDICTION_STATE_SEED: 'pred_market_state',
  USER_STATE_SEED: 'user_state',
  USER_POSITION_STATE_SEED: 'user_pos_state',
  REFERRAL_STATE_SEED: 'referrer_state',
  ADMIN_STATE_SEED: 'admin_state',
};

export enum ORDER_TYPE {
  BUY = 0,
  SELL = 1,
}

export enum ORDER_OUTCOME {
  YES = 0,
  NO = 1,
}

export enum MARKET_STATUS {
  OPEN = 0,
  CLOSED = 1,
  PAUSED = 2,
}

// Native SOL (wrapped SOL mint address - same on all networks)
export const inputMint = 'So11111111111111111111111111111111111111112';

// USDC addresses for different networks
export const USDC_MAINNET = 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v';
export const USDC_DEVNET = '4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU';

export const poolId = '3ucNos4NbumPLZNWztqGHNFFgkHeRMBQAVemeeomsUxv';

// Set outputMint based on your network configuration
export const outputMint = USDC_MAINNET; // or USDC_DEVNET based on your environment

// @ts-expect-error TYPE
export const isPhantomInstalled = window.phantom?.solana?.isPhantom;

export const getProvider = (wallet: Wallet) => {
  if (
    wallet.adapter.name === PhantomWalletName &&
    isPhantomInstalled &&
    env.VITE_PUBLIC_NETWORKS_MODE === 'mainnet'
  ) {
    // @ts-expect-error TYPE
    return window.phantom?.solana;
  }
  return null;
};
